import { initialBodySurveyState } from '../bodyAssessment/bodySurvey/store/bodySurvey.reducers'
import { AdditionalAssessmentsConstants } from './additionalAssessments.constants'
import { IAdditionalAssessmentsAction, IAdditionalAssessmentsState } from './additionalAssessments.types'

export const initialAdditionalAssessmentsState: IAdditionalAssessmentsState = {
  seq: 0,
  selectedAssessment: initialBodySurveyState,
  bodySurveys: [],
  deleteAssessment: null,
  assessmentSummaryDate: '',
  updatedFindings: null,
}

export function additionalAssessmentsReducer(
  state: IAdditionalAssessmentsState = initialAdditionalAssessmentsState,
  action: IAdditionalAssessmentsAction
): IAdditionalAssessmentsState {
  switch (action.type) {
    case AdditionalAssessmentsConstants.SET_SELECTED_ASSESSMENT:
      return { ...state, selectedAssessment: action.selectedAssessment }
    case AdditionalAssessmentsConstants.SET_BODY_SURVEY_ASSESSMENT_LIST:
      return { ...state, bodySurveys: action.bodySurveys }
    case AdditionalAssessmentsConstants.SET_ASSESSMENT_SUMMARY_DATE:
      return { ...state, assessmentSummaryDate: action.assessmentSummaryDate }
    case AdditionalAssessmentsConstants.SET_ASSESSMENTS_SEQUENCE:
      return { ...state, seq: action.seq }
    case AdditionalAssessmentsConstants.DELETE_ASSESSMENT:
      return { ...state, deleteAssessment: action.deleteAssessment }
    case AdditionalAssessmentsConstants.SET_ASSESSMENT_SUMMARY_UPDATED_FINDING:
      return { ...state, updatedFindings: action.updatedFindings }
    case AdditionalAssessmentsConstants.RESET_ASSESSMENTS:
      return {
        ...initialAdditionalAssessmentsState,
      }
    case AdditionalAssessmentsConstants.RESET_SELECTED_ASSESSMENT:
      return { ...state, selectedAssessment: { ...initialBodySurveyState } }
    default:
      return state
  }
}
